/*
  Theme customizations added by William Reid

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/




/* 
** Prevents a user right-clicking on a page to access context menu 
** Added by William 04/10/25
*/

document.addEventListener("contextmenu", function(e) {
  e.preventDefault();
});



/* 
** Prevents a user from dragging an image to download it
** Added by William 04/10/25
*/

function preventImageDragging() {
  document.querySelectorAll('img').forEach(img => {
    img.setAttribute('draggable', 'false');
    img.style.userSelect = 'none';
    img.addEventListener('contextmenu', e => e.preventDefault());
  });
}

// Run once immediately (for initial load)
preventImageDragging();

// Run again whenever the theme finishes loading a new page via AJAX
document.addEventListener('page:loaded', function() {
  preventImageDragging();
});

